<!-- 多个网点选择 -->
<template>
	<el-dialog title="可换机型查询" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
		style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose" v-el-drag-dialog
		v-el-dialog-center>
		<template style="margin-top: 40px;">
			<div id="containt" style="margin: 0;">
				<div class="grid-height">
					<div class="table_main" style="height: 400px!important;">
						<vxe-grid ref="table-m1" height="390" class="is-pointer" v-bind="vxeOption"
							@resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
							@checkbox-change="addDataTable" @checkbox-all="checkAll" @cell-dblclick="checkWithSubmit">

							<template #form>

								<vxe-form ref="form" class="screen-box"
									:label-position="right" label-width="70px"
									:data="searchData" @submit="searchEvent" @reset="searchEvent">
									<vxe-form-item title="产品编码:" span="6">
										<template v-slot>
											<el-input v-model="searchData.itemCode" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="产品名称:" span="6">
										<template v-slot>
											<el-input v-model="searchData.itemName" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="产品分类:" span="6">
										<template v-slot>
											<!-- <el-form-item :rules="[{ required: true, trigger: 'blur' }]"
												class="select_input">
												<el-select v-model="searchData.bigCategoryId" placeholder="大类"
													@change='productSelectOne' clearable style="width: 49%!important;">
													<el-option v-for="item in productOptions0" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
												<el-select v-model="searchData.smallCategoryId" placeholder="小类" clearable
													style="width: 49%!important;margin-left:2%;">
													<el-option v-for="item in productOptions1" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item> -->
											<el-form-item :rules="[{ required: true, trigger: 'blur' }]">
												<el-select v-model="searchData.bigCategoryId" placeholder="大类"
													@change='productSelectOne' style="width: 50%!important;">
													<el-option v-for="item in productOptions0" :key="item.value"
														:label="item.label" :value="item.value" clearable >
													</el-option>
												</el-select>
												<el-select v-model="searchData.smallCategoryId" placeholder="小类"
													style="width: 49%!important;margin-left:1%;">
													<el-option v-for="item in productOptions1" :key="item.value"
														:label="item.label" :value="item.value" clearable >
													</el-option>
												</el-select>
											</el-form-item>
										</template>
									</vxe-form-item>
									<vxe-form-item align="center" span="6">
										<template #default>
										<vxe-button status="warning" icon="el-icon-search" class="button-sty" content="搜索"
												@click="searchEvent"></vxe-button>
										</template>
									</vxe-form-item>
									<vxe-form-item title="长*宽*高:" span="6" align="left">
										<template v-slot>
											&nbsp;<el-input v-model="searchData.length" size="small" clearable
												style="width: 4vw!important;" />
											&nbsp;*&nbsp;<el-input v-model="searchData.width" size="small" clearable
											style="width: 4vw!important;" />
											&nbsp;*&nbsp;<el-input v-model="searchData.height" size="small" clearable
												style="width: 4vw!important;" />
										</template>
									</vxe-form-item>
									<vxe-form-item title="价格段:" span="6" align="left">
											<template v-slot>
												&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="searchData.priceBegin" size="small" clearable
													style="width: 4vw!important;" />
												&nbsp;-&nbsp;<el-input v-model="searchData.priceEnd" size="small"
												style="width: 4vw!important;" clearable />
											</template>
									<!-- </vxe-form-item>
									<vxe-form-item>
											<template v-slot>
												&nbsp;-&nbsp;<el-input v-model="searchData.priceEnd" size="small"
													style="width: 4vw!important;" clearable />
											</template> -->
									</vxe-form-item>
									<vxe-form-item title="出库仓:" span="6">
										<template v-slot>
											<el-select v-model="searchData.outWarehouseId" filterable="true" >
												<el-option v-for="item in outWarehouseList" @click="searchEvent"
													:key="item.id"
													:label="item.warehouseName + '(' + item.warehouseCode + ')'"
													:value="item.id">
												</el-option>
											</el-select>
										</template>
									</vxe-form-item>
									<vxe-form-item title="erp客户编码:" span="6" align="left">
										<template v-slot>
											<el-input v-model="searchData.erpCustCode" size="small" clearable />
										</template>
									</vxe-form-item>
								</vxe-form>
								<!-- <div class="clearfix screen-btns">
									<div class="fr" style="display: inline-block;
											float: right;
											margin-top: -39px;">
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div> -->
							</template>
							<template #number="{row}">
								<el-input type="number" min="1" v-model="row.qty" max="1000" size="small" @input="inputSearch($event)"  clearable />
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</div>
		</template>
		<label id="labBtn" class="transverse">
			<div class="icon">
				<i class="el-icon-more"></i>
				<i class="el-icon-more"></i>
			</div>
		</label>
		<div class="multipleChoice">
			<el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
				<a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
			</el-tooltip>
			<div class="list">
				<div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.itemId">
					<p>{{ checkRow.itemCode }}</p>
					<a class="el-icon-close" @click="clearTable1Select(index)"></a>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="submitBackMachine" :diabled="siteAppealButton" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import Ar from "element-ui/src/locale/lang/ar";
import { createLogger } from 'vuex';
import { min } from 'xe-utils';
export default {
	name: 'saleConfigDialog',

	mixins: [selectDialogMixins],
	components: { pager },
	props: ['excludeList', 'dataId', 'bigCategoryId', 'bigCategoryName', 'smallCategoryId', 'smallCategoryName', 'wf', 'obj',],
	created() {
		// this.searchData.bigCategoryId = this.bigCategoryId
		// this.searchData.bigCategoryName = this.bigCategoryName
		// this.searchData.smallCategoryId = this.smallCategoryId
		// this.searchData.smallCategoryName = this.smallCategoryName
		// this.bigS=this.bigS
		// console.log(this.bigS,"bigs的值");

		this.formData.id = this.dataId
		if(this.wf){
			this.formData.processId = this.wf.processId
			this.formData.taskId = this.wf.taskId
			this.formData.messageContent = this.wf.messageContent
			this.formData.id = this.wf.orderId
			if (this.wf.wfView) {
				this.wfView = this.wf.wfView
				if (this.wfView.indexOf('?') != -1) {
					var queryString = this.wfView.split('?')[1];
					let params = new URLSearchParams(queryString);
					this.formData.index = params.has('index') ? params.get('index') : 0;
				}
			}
		}
		if (this.obj) {
			this.searchData.erpCustCode = this.obj.erpCustCode
		}

		this.initSetting();
		if(this.bigS) {
			this.bigD=this.bigS
		}
		console.log(this.bigD,this.dataId,this.excludeList,"bigs的值");
	},

	mounted() {
		// this.nbigs=this.bigS

		this.loadProductOption0()
		// this.loadProductOption2()
		this.loadProductOption1()

		this.loadOutWarehouse()

		console.log(this.excludeList)
		if (this.excludeList) {
			this.formData.excludeId = this.excludeList.map(item => item.id)
		}
	},

	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},

	data() {
		return {
			number:'',
			bigD:{},
			checkRows:[],
			productOptions0: [],
			productOptions1: [],
			total: 0,
			filterText: '',
			data: [],
			outWarehouseList: [],

			siteAppealButton: false,

			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			isRouterAlive: true,
			// 查询参数
			searchData: {
				itemCode: null,
				itemName: null,
				bigCategoryId: null,
				smallCategoryId: null,
				itemUsable: 1, // 查产品价格默认只查可用的
				length: null,
				width: null,
				height: null,
				priceBegin: null,
				priceEnd: null,
				outWarehouseId: null,
				erpCustCode: '',

				size: null,
				current: null,
				searchCount: null,
			},
			formData: {
				id: null,
				processId: null,
				taskId: null,
				messageContent: "",
				outWarehouseId: null,
				erpCustCode: '',
				index:null,
				backList: [],

				size: 0,
				current: 1,
				searchCount: false,
			},
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			selectedRow: {
				id: '', name: ''
			},
			wfView: '',
			number:''

		};
	},


	methods: {
		inputSearch(val){
			console.log(val,'输入的val');
			this.number=val
		},

		// selectChangeEvent2(data) {
		// 	console.log('选中的数据', data)
		// 	// this.formData.backList = data.records

		// 	if (!this.checkRows || this.checkRows.length < 1) {
		// 		this.checkRows = data.records
		// 	} else {

		// 	}
		// 	console.log(this.checkRows,"this.checkRows的值");
		// },


		loadOutWarehouse() {
			this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
			}).then(res => {
				this.outWarehouseList = res.data.data
			})
		},

		// 产品大类选中加载小类
		productSelectOne() {
			this.productOptions1 = []
			this.searchData.smallCategoryId = null
			this.loadProductOption1()
		},
		// 加载产品大类
		loadProductOption0() {
			fetchTree({
				categoryType: 1,  // 产品
				// exchangeShow: 1, // 退换货展示为是
				// usable: 1  // 加载启用的
			}).then(response => {
				this.productOptions0 = []
				response.data.data.forEach(item => {
					this.productOptions0.push({
						label: item.categoryName,
						value: item.id
					})
				})
			});
		},

		// 加载产品小类
		loadProductOption1() {
			if (this.searchData.bigCategoryId === ''
				|| this.searchData.bigCategoryId === null
				|| this.searchData.bigCategoryId === undefined) {
				this.productOptions1 = []
			} else {
				fetchTree({
					categoryType: 1,  // 产品
					// usable: 1,  // 加载启用的
					parentId: this.searchData.bigCategoryId
				}).then(response => {
					this.productOptions1 = []
					response.data.data.forEach(item => {
						this.productOptions1.push({
							label: item.categoryName,
							value: item.id
						})
					})
				})
			}
		},

		// 确认提交
		submitBackMachine() {
			console.log(this.checkRows,"this.checkRows的值");

			let hasProduct = (this.checkRows && this.checkRows.length > 0)
			// if (!hasProduct) {
			// 	this.$message.error('请选择产品')
			// 	return false;
			// }
			if (!hasProduct && this.formData.index && this.formData.index == '1') {
				this.$message.error('请选择产品')
				return false;
			}

			this.formData.outWarehouseId = this.searchData.outWarehouseId;
			this.formData.erpCustCode = this.searchData.erpCustCode;
			if (!this.formData.outWarehouseId && this.formData.index && this.formData.index == '1') {
				this.$message.error('请选择出库仓')
				return false;
			}
			if (!this.formData.erpCustCode) {
				this.$message.error('请填写erp客户条码')
				return false;
			}

			let submitCheckCode = '';
			// 重复提交会有问题 先清空掉
			this.formData.backList = [];
			if (this.checkRows && this.checkRows.length > 0) {
				this.checkRows.forEach(item => {
					console.log(item)
					// if (!item.qty) {
					// 	item.qty = 1
					// }
					if (!item.qty || item.qty < 1) {
						submitCheckCode = item.itemCode
						return false
					}

					this.formData.backList.push({
						itemId: item.itemId, itemName: item.itemName, itemCode: item.itemCode,
						bigCategoryId: item.bigCategoryId, bigCategoryName: item.bigCategoryName,
						smallCategoryId: item.smallCategoryId, smallCategoryName: item.smallCategoryName,
						entId: item.entId,
						qty: item.qty, price: item.price,
					})
				})
			}
			if (submitCheckCode) {
				this.$message.error('已选择产品' + submitCheckCode + ',请输入产品数量,需要大于0')
				return false;
			}
			let url = api.wkExchangeBill.addDataUrl + 'backDispose'
			// if (this.$route.query.index && this.$route.query.index == '1') {
			// 	url = api.wkExchangeBill.addDataUrl + 'schemeEntry'
			// }
			let comfirmTitle = "是否确认提交?"
			if (!this.checkRows || this.checkRows.length < 1) {
				// this.$message.error('')
				// return false;
				comfirmTitle = "当前未选择产品, " + comfirmTitle;
			}
			this.$baseConfirm(comfirmTitle).then(() => {
				this.$mask.open()
				console.log("???");


				this.$http({
					url: url,
					method: 'post',
					data: this.formData
				}).then(res => {
					this.$mask.close()
					this.$message.success('确认成功')
					this.$emit('closeD')
					this.$emit('flushed')
				}).catch(() => {
					this.$mask.close()
				})
			});
		},

		selectChangeEvent({ records }) {
			this.formData.backList = []
			records.forEach(item => {
				console.log("11")
				console.log(item)
				this.formData.backList.push({
					itemId: item.itemId, itmeName: item.itemName, itemCode: item.itemCode,
					bigCategoryId: item.bigCategoryId, bigCategoryName: item.bigCategoryName,
					smallCategoryId: item.smallCategoryId, smallCategoryName: item.smallCategoryName,
					entId: item.entId,
					qty: 1, price: item.price,
				})
			})
		},

		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},


		// 分页功能
		changeTablePage(page, flag) {
			this.searchData.size = page.pageSize
			this.searchData.current = page.currentPage
			this.searchData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
			if (!this.searchData.outWarehouseId) {
				this.$message.error('请选择出库仓')
				return false;
			}
			// console.log(this.number,"this.number的值");
			this.$refs.pager.clearStoreTableDataTotal()
			this.searchData.current = 1
			this.searchData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
			this.searchData.itemCode = ''
			this.searchData.itemName = ''
			this.searchData.brandName = ''
			this.formData.current = 1
			this.formData.searchCount = false
			this.formData.bigCategoryId = ''
			this.formData.smallCategoryId = ''
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
			this.reloadTree()
		},


		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},


		reloadTree() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},

		// 点击的树形 点
		handleNodeClick(node, data) {
			let id = data.data.id;
			if (data.level === 1) {
				this.formData.bigCategoryId = id;
				this.formData.smallCategoryId = '';
			} else {
				this.formData.smallCategoryId = id;
			}

			this.initTableList();
			this.flushed()
		},

		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.basItemPrice.getItemPriceUrl,
				param: this.searchData,
				method: 'get',
				columns: [
					{ type: "checkbox", width: 40, title: '', resizable: false, fixed: 'left' },
					{ title: '数量', field: 'qty', width: 140, slots: {default: 'number'
							// default: ({ row }) => {
							// 	return [
							// 		<vxe-input type="number" min="1" max="1000" size="small" clearable />
							// 	]
							// }
						}
					},
					{ title: '品牌', field: 'brandName', width: 140, },
					{ title: '产品编码', field: 'itemCode', width: 140, },
					{ title: '产品名称', field: 'itemName', width: 110, },
					{ title: '产品大类', field: 'bigCategoryName', width: 140 },
					{ title: '产品小类', field: 'smallCategoryName', width: 110, },
					{ title: '价格', field: 'price', width: 110, },
					{
						title: '长*宽*高', field: 'bbb', width: 110, slots: {
							default: ({ row }) => {
								return "" + (row.length?row.length:'') + "*" + (row.width?row.width:'') + "*" + (row.height?row.height:'')
							}
						}
					},
					{ title: '库存', field: 'invQty', width: 110, },
					{
						field: 'stat', title: '是否电商产品', width: 150, slots: {
							default: ({ row }) => {
								if (row.stat == 1) {
									return [
										<div class="txt-status ">
											<span>是</span>
										</div>
									];
								} else {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								}
							}
						}
					},
					{ title: '重量', field: 'weight', width: 110, },
					{
						title: '状态', feild: 'usable', width: 110, slots: {
							default: ({ row }) => {
								if (row.usable == 1) {
									return [
										<div class="txt-status ">
											<span>启用</span>
										</div>
									];
								} else if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								}
							}
						}
					},
				]
			};
			this.vxeOption = initVxeTable(tableOption);
			this.flushed()

		},

		confirm() {
			this.drawer = false;
			this.handleClose()
		},
		cancelForm() {
			this.loading = false;
			this.drawer = false;
			clearTimeout(this.timer);
		},
		handleClose() {
			this.drawer = false;
			this.$emit('closeD', false)
		},


		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
				parentId: node.data.id,
				categoryType: 1
			}).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});

		},

	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 400px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
	display: block;
	width: 100%;
	position: fixed;
	bottom: -40px !important;
	position: absolute !important;
	z-index: 9;
	background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

	z-index: 99999;
}
</style>
